import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import { PromiseType } from '../../types';
import * as UserManager from '../domain/user-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';

type ContextState = Data<UserListData>;
type UserListData = PromiseType<ReturnType<typeof UserManager.getUserList>>;

const Context = React.createContext<ContextState | null>(null);

function useUserListData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useUserListData must be used within a TrendDataProvider');
    }
    return contextState;
}

const UserListDataProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'user-list-data',
        id: props.siteId,
        dataFn: React.useCallback(
            (): Promise<UserListData> => UserManager.getUserList(authHelper, props.siteId),
            [props.siteId, authHelper]
        ),
    });

    return <Context.Provider value={dataFromDataset(dataset)}>{props.children}</Context.Provider>;
};
const TestUserListDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { UserListDataProvider, TestUserListDataProvider, useUserListData };
